import Api from './ApiRequest';

export default {
    listTasks: () => Api.get(`/cent/tasks`),
    getTask: (id) => Api.get(`/cent/task/${id}`),
    listJobs: (taskId, fromId) => Api.get(`/cent/task/${taskId}/jobs`, !!fromId ? {fromId} : null)
};
